module.exports = __webpack_public_path__ + "static/hero-012ad9a63f2147f2cc4dd7883cfce71c.png";